import { getWindow } from './getWindow.tsx';

export const getNavigator = (): Navigator | undefined => getWindow()?.navigator;
